import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectModule, selectLoading, selectLoaded } from '../selectors/module.selector';
import { moduleActions } from '../actions/module.actions';

@Injectable({
    providedIn: 'root',
})
export class ModuleFacade {
    private store = inject(Store);

    // rxjs
    readonly loaded$ = (id: string) => this.store.select(selectLoaded(id));
    readonly loading$ = (id: string) => this.store.select(selectLoading(id));
    readonly module$ = (id: string) => this.store.select(selectModule(id));
    readonly moduleNonNullable$ = (id: string) => this.store.select(selectModule(id)).pipe(filter((data) => data !== null));

    // signals
    readonly loaded = (id: string) => this.store.selectSignal(selectLoaded(id));
    readonly loading = (id: string) => this.store.selectSignal(selectLoading(id));
    readonly module = (id: string) => this.store.selectSignal(selectModule(id));

    getModule(id: string) {
        this.store.dispatch(moduleActions.getModule({ id }));
    }

    clear() {
        this.store.dispatch(moduleActions.clear());
    }
}
